import { render, staticRenderFns } from "./selectedGoods.vue?vue&type=template&id=66dd6776&scoped=true&"
import script from "./selectedGoods.vue?vue&type=script&lang=js&"
export * from "./selectedGoods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66dd6776",
  null
  
)

export default component.exports